import { Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SessionService } from '../../services/session.service';
import { UserService } from '../../services/user/user.service';
import { PastDueService, PastDueSummary } from '../../services/pastDue.service';

@Component({
  selector: 'app-past-due-banner',
  templateUrl: './past-due-banner.component.html',
  styleUrls: ['./past-due-banner.component.scss'],
})
export class PastDueBannerComponent implements OnInit, OnDestroy {
  isBuyer = false;
  facilityId: number | null = null;

  pastDueSummary: PastDueSummary | null = null;
  pastDueCount = 0;
  pastDueAmount = 0;

  subs: Subscription = new Subscription();

  constructor(
    private sessionService: SessionService,
    private userService: UserService,
    public pastDue: PastDueService,
  ) {}

  ngOnInit() {
    if (!this.pastDue.enabled()) {
      return;
    }
    this.getProfileInformation();
    this.watchPrimaryFacilityUpdatedTrigger();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  watchPrimaryFacilityUpdatedTrigger() {
    const s = this.sessionService.primaryFacilityUpdatedTrigger.subscribe(
      () => this.getProfileInformation(),
    );
    this.subs.add(s);
  }

  getProfileInformation() {
    const s = this.userService.getMe().subscribe(res => {
      const user = res.data;
      this.isBuyer =
        !!user.roles?.includes('Buyer') &&
        !user.is_sales_representative &&
        !user.is_customer_representative;
      this.facilityId = user.primary_facility?.id ?? null;
      this.checkPastDue();
    });
    this.subs.add(s);
  }

  checkPastDue() {
    this.pastDueSummary = null;
    this.pastDueCount = 0;
    this.pastDueAmount = 0;
    if (!this.pastDue.enabled() || !this.isBuyer || !this.facilityId) {
      return;
    }
    const s = this.pastDue
      .getFacilitySummary(this.facilityId)
      .subscribe(summary => {
        this.pastDueSummary = summary;
        this.pastDueCount = summary.count;
        this.pastDueAmount = summary.total_amount;
      });
    this.subs.add(s);
  }
}

@NgModule({
  declarations: [PastDueBannerComponent],
  imports: [CommonModule],
  exports: [PastDueBannerComponent],
})
export class PastDueBannerModule {}
